import request from '@/auth/jwt/request'

// 数据组管理

/**
 * @description -- 数据组列表 --
 * @param {Object} param params {Object} 传值参数
 */
export const groupList = params => { return request('group/list', 'get', params) }

/**
 * @description -- 更新数据组 --
 * @param {Object} param params {Object} 传值参数
 */
export const groupSave = data => { return request('group/save', 'post', {}, data) }


/**
 * @description -- 删除数据组 --
 * @param {Object} param params {Object} 传值参数
 */
 export const groupDelete = data => { return request( 'group/delete', 'delete', data) }

/**
 * @description -- 数据组详情 --
 * @param {Object} param params {Object} 传值参数
 */
export const groupInfo = params => { return request( 'group/info', 'get', params) }

// 数据组中数据管理

/**
 * @description -- 数据组数据表头 --
 * @param {Object} param params {Object} 传值参数
 */
export const groupDataHeader = params => { return request( 'groupdata/header', 'get', params) }

/**
 * @description -- 数据组中数据列表 --
 * @param {Object} param params {Object} 传值参数
 */
 export const groupDataList = params => { return request( 'groupdata/list', 'get', params ) }

/**
 * @description -- 更新数据组中数据 --
 * @param {Object} param params {Object} 传值参数
 */
export const groupDataSave = data => { return request('groupdata/save', 'post', {}, data ) }

/**
 * @description -- 删除数据组中数据 --
 * @param {Object} param params {Object} 传值参数
 */
 export const groupDataDelete = data => { return request( 'groupdata/delete', 'delete', data) }

/**
 * @description -- 数据组中数据状态 --
 * @param {Object} param params {Object} 传值参数
 */
 export const groupDataStatus = params => { return request( 'groupdata/status', 'get', params) }
